import { JwtTokenFullData } from '../../common';
import { IJwtWithApiKey } from './types';

// Builds worker token data from a JWT the backend has already converted. Returns undefined when there's
// nothing converted (e.g. an encrypted JWT), so the caller can fall back to
// decrypting and importing it on the client.
export const getJwtTokenFullDataFromApiKey = ({
  api_key: apiKey,
  jwt_data: signedToken,
}: Pick<IJwtWithApiKey, 'api_key' | 'jwt_data'>):
  | JwtTokenFullData
  | undefined => {
  if (!apiKey) {
    return undefined;
  }

  const { enterpriseApiKeys, partnerChains, tier, token } = apiKey;

  return {
    workerTokenData: {
      signedToken,
      userEndpointToken: token,
      tier,
      enterpriseApiKeys,
      partnerChains,
    },
  };
};
